// src/context/ThemeContext.js
import React, { createContext, useState } from 'react';

const ThemeContext = createContext();

const lightTheme = {
    backgroundColor: '#ffffff',
    color: '#000000',
    sideBarBg: 'rgb(51, 66, 96)',
    buttonBackgroundColor: '#007bff',
    hightlightColor: '#7a5af8',
    buttonColor: '#ffffff',
};

const darkTheme = {
    backgroundColor: '#333333',
    color: '#ffffff',
    sideBarBg: '#000',
    buttonBackgroundColor: '#555555',
    hightlightColor: '#333333',
    buttonColor: '#ffffff',
};

const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(lightTheme);
    const [themeMode, setThemeMode] = useState('default');

    const toggleTheme = () => {
        setTheme((prevTheme) =>
            prevTheme === lightTheme ? darkTheme : lightTheme
        );
        setThemeMode((prevThemeMode) =>
            prevThemeMode === 'default' ? 'dark' : 'default'
        );
    };
    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, themeMode, setThemeMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

export { ThemeContext, ThemeProvider };
